/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DiscreteNumericListDto } from './DiscreteNumericListDto';
import {
    DiscreteNumericListDtoFromJSON,
    DiscreteNumericListDtoFromJSONTyped,
    DiscreteNumericListDtoToJSON,
} from './DiscreteNumericListDto';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface PhotonBeamQualityDoseRateValueListDto
 */
export interface PhotonBeamQualityDoseRateValueListDto {
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    radiationType: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    energy: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    highDoseTechniqueType: EnumerationValueDto;
    /**
     * 
     * @type {DiscreteNumericListDto}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    selectedDoseRates: DiscreteNumericListDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    primaryFluenceShaping: EnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDoseRateValueListDto
     */
    $type?: PhotonBeamQualityDoseRateValueListDtoTypeEnum;
}


/**
 * @export
 */
export const PhotonBeamQualityDoseRateValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersPhotonBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.PhotonBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PhotonBeamQualityDoseRateValueListDtoTypeEnum = typeof PhotonBeamQualityDoseRateValueListDtoTypeEnum[keyof typeof PhotonBeamQualityDoseRateValueListDtoTypeEnum];



/**
 * Check if a given object implements the PhotonBeamQualityDoseRateValueListDto interface.
 */
export function instanceOfPhotonBeamQualityDoseRateValueListDto(value?: unknown): value is PhotonBeamQualityDoseRateValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PhotonBeamQualityDoseRateValueListDtoTypeEnum)[0];
}

export function PhotonBeamQualityDoseRateValueListDtoFromJSON(json: any): PhotonBeamQualityDoseRateValueListDto {
    return PhotonBeamQualityDoseRateValueListDtoFromJSONTyped(json, false);
}

export function PhotonBeamQualityDoseRateValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotonBeamQualityDoseRateValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'beamQualityId': json['beamQualityId'] == null ? undefined : json['beamQualityId'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'radiationType': EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'selectedDoseRates': DiscreteNumericListDtoFromJSON(json['selectedDoseRates']),
        'primaryFluenceShaping': EnumerationValueDtoFromJSON(json['primaryFluenceShaping']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PhotonBeamQualityDoseRateValueListDtoToJSON(value?: PhotonBeamQualityDoseRateValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'iuid': value['iuid'],
        'beamQualityId': value['beamQualityId'],
        'isEnabled': value['isEnabled'],
        'radiationType': EnumerationValueDtoToJSON(value['radiationType']),
        'energy': NumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        'selectedDoseRates': DiscreteNumericListDtoToJSON(value['selectedDoseRates']),
        'primaryFluenceShaping': EnumerationValueDtoToJSON(value['primaryFluenceShaping']),
        '$type': value['$type'],
    });
}

